export const translations = {
  ro: {
    // Header
    nav: {
      services: "Servicii",
      fleet: "Flota",
      reviews: "Recenzii",
      contact: "Contact"
    },
    
    // Hero
    hero: {
      badge: "Serviciu NCC Premium Torino",
      title: "Eleganță și",
      titleHighlight: "Profesionalism",
      titleEnd: "pe Drum",
      subtitle: "Serviciu NCC de lux cu Mercedes Clasa V. Transferuri la aeroport, evenimente corporate și tururi personalizate. Experiența ta premium de călătorie în Torino.",
      trustBadge1: "Asigurat",
      trustBadge2: "24/7",
      trustBadge3: "Rating 5.0",
      ctaPrimary: "Rezervă pe WhatsApp",
      ctaSecondary: "Solicită Ofertă",
      scrollText: "Descoperă mai mult"
    },
    
    // Services
    services: {
      badge: "Serviciile Noastre",
      title: "Soluții Personalizate pentru Fiecare Nevoie",
      subtitle: "De la transfer la aeroport la tur personalizat, oferim servicii premium pentru clienți business și de lux",
      service1: {
        title: "Transferuri la Aeroport",
        description: "Serviciu profesional de și către aeroporturile Malpensa, Linate și Bergamo. Punctualitate garantată și confort maxim.",
        features: ["Monitorizare zboruri", "Meet & Greet", "Asistență bagaje"]
      },
      service2: {
        title: "Servicii Corporate",
        description: "Soluții de transport dedicate pentru întâlniri, evenimente corporate și călătorii de afaceri. Discreție și profesionalism.",
        features: ["Facturare electronică", "Serviciu continuu", "Multiple destinații"]
      },
      service3: {
        title: "Ceremonii și Evenimente",
        description: "Faceți ziua voastră specială unică cu serviciul nostru premium pentru nunți, aniversări și sărbători.",
        features: ["Mașină decorată", "Serviciu personalizat", "Fotograf disponibil"]
      },
      service4: {
        title: "Tururi în Langhe",
        description: "Explorați minunile regiunii Langhe cu tururi enogastronomice personalizate. Relaxare și descoperirea teritoriului.",
        features: ["Itinerarii personalizate", "Crame și restaurante", "Ghid turistic"]
      }
    },
    
    // Fleet
    fleet: {
      badge: "Flota Noastră",
      title: "Mercedes-ul Nostru",
      titleHighlight: "Clasa V",
      subtitle: "Vehiculul nostru premium pentru confort și stil maxim în deplasările tale",
      vehicleBadge: "Vehiculul Nostru",
      category: "Van Premium",
      passengers: "Pasageri",
      luggage: "Bagaje",
      color: "Negru",
      comfortTitle: "Confort & Servicii",
      features: ["Aer condiționat", "Wi-Fi", "Scaune din piele", "Apă îmbuteliată"],
      footer: "Vehiculul nostru este întreținut regulat, igienizat și dotat cu asigurare completă"
    },
    
    // Testimonials
    testimonials: {
      badge: "Testimoniale",
      title: "Ce Spun Clienții Noștri",
      subtitle: "Excelența serviciului se măsoară prin satisfacția clienților",
      trustBadge: "pe Google Reviews",
      reviews: [
        {
          id: 1,
          text: "Serviciu impecabil. Am folosit Rent With Driver pentru mai multe transferuri de afaceri și nu am avut niciodată probleme. Șofer profesional și punctual.",
          name: "Marco Bianchi",
          role: "CEO, Tech Solutions",
          date: "Ianuarie 2025",
          rating: 5
        },
        {
          id: 2,
          text: "Nunta noastră a fost perfectă și datorită serviciului lor. Mercedes impecabil și șofer foarte amabil. Foarte recomandat!",
          name: "Laura Rossi",
          role: "Mireasă",
          date: "Decembrie 2024",
          rating: 5
        },
        {
          id: 3,
          text: "Folosesc acest serviciu pentru transferurile mele de la Malpensa la Torino. Întotdeauna punctual, confortabil și profesional. Top!",
          name: "Giovanni Ferrari",
          role: "Business Traveler",
          date: "Noiembrie 2024",
          rating: 5
        },
        {
          id: 4,
          text: "Am făcut un tur minunat în Langhe. Șoferul cunoștea toate cele mai bune locuri. Experiență de repetat!",
          name: "Sofia Martini",
          role: "Client privat",
          date: "Octombrie 2024",
          rating: 5
        }
      ]
    },
    
    // Coverage
    coverage: {
      badge: "Zona de Acoperire",
      title: "Unde Operăm",
      subtitle: "Serviciu de încredere din Torino către principalele destinații din nordul Italiei",
      fromTurin: "de la Torino",
      footer1: "Destinație nu e în listă?",
      footer2: "Contactați-ne pentru oferte personalizate către orice destinație din Italia"
    },
    
    // Contact
    contact: {
      badge: "Contactează-ne",
      title: "Solicită o Ofertă",
      subtitle: "Completează formularul sau contactează-ne direct pe WhatsApp pentru o ofertă imediată",
      form: {
        name: "Nume Complet",
        email: "Email",
        phone: "Telefon",
        service: "Serviciu Solicitat",
        servicePlaceholder: "Selectează un serviciu",
        serviceOptions: {
          airport: "Transfer Aeroport",
          business: "Serviciu Corporate",
          ceremony: "Ceremonie/Eveniment",
          tour: "Tur Langhe",
          other: "Altele"
        },
        date: "Data Estimată",
        message: "Note Suplimentare",
        messagePlaceholder: "Detalii călătorie, număr pasageri, bagaje, etc...",
        submit: "Trimite Cerere pe WhatsApp",
        required: "Vă rugăm completați toate câmpurile obligatorii",
        success: "Redirecționare către WhatsApp..."
      },
      whatsapp: {
        title: "Contact Direct",
        subtitle: "Răspuns imediat pe WhatsApp",
        cta: "Conversație pe WhatsApp"
      },
      why: {
        title: "De Ce Să Ne Alegi?",
        reason1: "Disponibilitate 24/7 pentru urgențe și rezervări de ultimă oră",
        reason2: "Șoferi profesioniști, discreți și multilingvi",
        reason3: "Vehicule Mercedes de lux, întotdeauna impecabile",
        reason4: "Tarife transparente fără costuri ascunse",
        reason5: "Plăți flexibile: numerar, card, transfer bancar"
      }
    },
    
    // Footer
    footer: {
      description: "Serviciu NCC premium în Torino. Transferuri la aeroport, evenimente corporate și tururi personalizate cu Mercedes Clasa V.",
      quickLinks: "Link-uri Rapide",
      contacts: "Contact",
      whatsapp24: "WhatsApp 24/7",
      location: "Torino, Piemont",
      country: "Italia",
      copyright: "Toate drepturile rezervate.",
      privacy: "Politica de Confidențialitate",
      terms: "Termeni și Condiții"
    }
  },
  
  it: {
    // Header
    nav: {
      services: "Servizi",
      fleet: "Flotta",
      reviews: "Recensioni",
      contact: "Contatti"
    },
    
    // Hero
    hero: {
      badge: "Servizio Premium NCC Torino",
      title: "Eleganza e",
      titleHighlight: "Professionalità",
      titleEnd: "su Strada",
      subtitle: "Servizio NCC di lusso con Mercedes Classe V. Trasferimenti aeroportuali, eventi aziendali e tour personalizzati. La tua esperienza di viaggio premium a Torino.",
      trustBadge1: "Assicurato",
      trustBadge2: "H24 / 7gg",
      trustBadge3: "5.0 Rating",
      ctaPrimary: "Prenota su WhatsApp",
      ctaSecondary: "Richiedi Preventivo",
      scrollText: "Scopri di più"
    },
    
    // Services
    services: {
      badge: "I Nostri Servizi",
      title: "Soluzioni su Misura per Ogni Esigenza",
      subtitle: "Dal trasferimento aeroportuale al tour personalizzato, offriamo servizi premium per clienti business e luxury",
      service1: {
        title: "Trasferimenti Aeroportuali",
        description: "Servizio professionale da e per gli aeroporti di Malpensa, Linate e Bergamo. Puntualità garantita e massimo comfort.",
        features: ["Monitoraggio voli", "Meet & Greet", "Assistenza bagagli"]
      },
      service2: {
        title: "Servizi Aziendali",
        description: "Soluzioni di trasporto dedicate per meeting, eventi corporate e trasferte di lavoro. Discrezione e professionalità.",
        features: ["Fatturazione elettronica", "Servizio continuativo", "Multi-destinazioni"]
      },
      service3: {
        title: "Cerimonie ed Eventi",
        description: "Rendete speciale il vostro giorno importante con il nostro servizio premium per matrimoni, anniversari e celebrazioni.",
        features: ["Auto decorata", "Servizio personalizzato", "Fotografo disponibile"]
      },
      service4: {
        title: "Tour nelle Langhe",
        description: "Esplorate le meraviglie delle Langhe con tour enogastronomici personalizzati. Relax e scoperta del territorio.",
        features: ["Itinerari personalizzati", "Cantine e ristoranti", "Guida turistica"]
      }
    },
    
    // Fleet
    fleet: {
      badge: "La Nostra Flotta",
      title: "La Nostra",
      titleHighlight: "Mercedes Classe V",
      subtitle: "Il nostro veicolo premium per il massimo comfort e stile nei tuoi spostamenti",
      vehicleBadge: "Il Nostro Veicolo",
      category: "Premium Van",
      passengers: "Passeggeri",
      luggage: "Bagagli",
      color: "Nero",
      comfortTitle: "Comfort & Servizi",
      features: ["Aria condizionata", "Wi-Fi", "Poltrone in pelle", "Bottled water"],
      footer: "Il nostro veicolo è regolarmente manutenuto, igienizzato e dotato di assicurazione completa"
    },
    
    // Testimonials
    testimonials: {
      badge: "Testimonianze",
      title: "Cosa Dicono i Nostri Clienti",
      subtitle: "L'eccellenza del servizio si misura dalla soddisfazione dei clienti",
      trustBadge: "su Google Reviews",
      reviews: [
        {
          id: 1,
          text: "Servizio impeccabile. Ho utilizzato Rent With Driver per diversi trasferimenti aziendali e non ho mai avuto problemi. Autista professionale e puntuale.",
          name: "Marco Bianchi",
          role: "CEO, Tech Solutions",
          date: "Gennaio 2025",
          rating: 5
        },
        {
          id: 2,
          text: "Il nostro matrimonio è stato perfetto anche grazie al loro servizio. Mercedes impeccabile e autista gentilissimo. Consigliatissimo!",
          name: "Laura Rossi",
          role: "Sposa",
          date: "Dicembre 2024",
          rating: 5
        },
        {
          id: 3,
          text: "Utilizzo questo servizio per i miei trasferimenti da Malpensa a Torino. Sempre puntuale, comfortable e professionale. Top!",
          name: "Giovanni Ferrari",
          role: "Business Traveler",
          date: "Novembre 2024",
          rating: 5
        },
        {
          id: 4,
          text: "Abbiamo fatto un tour nelle Langhe meraviglioso. L'autista conosceva tutti i posti migliori. Esperienza da ripetere!",
          name: "Sofia Martini",
          role: "Cliente privata",
          date: "Ottobre 2024",
          rating: 5
        }
      ]
    },
    
    // Coverage
    coverage: {
      badge: "Area di Copertura",
      title: "Dove Operiamo",
      subtitle: "Servizio affidabile da Torino verso le principali destinazioni del Nord Italia",
      fromTurin: "da Torino",
      footer1: "Destinazione non in lista?",
      footer2: "Contattateci per preventivi personalizzati verso qualsiasi destinazione in Italia"
    },
    
    // Contact
    contact: {
      badge: "Contattaci",
      title: "Richiedi un Preventivo",
      subtitle: "Compila il form o contattaci direttamente su WhatsApp per un preventivo immediato",
      form: {
        name: "Nome Completo",
        email: "Email",
        phone: "Telefono",
        service: "Servizio Richiesto",
        servicePlaceholder: "Seleziona un servizio",
        serviceOptions: {
          airport: "Trasferimento Aeroportuale",
          business: "Servizio Aziendale",
          ceremony: "Cerimonia/Evento",
          tour: "Tour Langhe",
          other: "Altro"
        },
        date: "Data Prevista",
        message: "Note Aggiuntive",
        messagePlaceholder: "Dettagli del viaggio, numero passeggeri, bagagli, ecc...",
        submit: "Invia Richiesta su WhatsApp",
        required: "Per favore, compila tutti i campi obbligatori",
        success: "Reindirizzamento a WhatsApp..."
      },
      whatsapp: {
        title: "Contatto Diretto",
        subtitle: "Risposta immediata su WhatsApp",
        cta: "Chatta su WhatsApp"
      },
      why: {
        title: "Perché Sceglierci?",
        reason1: "Disponibilità 24/7 per emergenze e prenotazioni last-minute",
        reason2: "Autisti professionali, discreti e multilingue",
        reason3: "Veicoli Mercedes di lusso, sempre impeccabili",
        reason4: "Tariffe trasparenti senza costi nascosti",
        reason5: "Pagamenti flessibili: contanti, carta, bonifico"
      }
    },
    
    // Footer
    footer: {
      description: "Servizio NCC premium a Torino. Trasferimenti aeroportuali, eventi aziendali e tour personalizzati con Mercedes Classe V.",
      quickLinks: "Link Rapidi",
      contacts: "Contatti",
      whatsapp24: "WhatsApp 24/7",
      location: "Torino, Piemonte",
      country: "Italia",
      copyright: "Tutti i diritti riservati.",
      privacy: "Privacy Policy",
      terms: "Termini di Servizio"
    }
  },
  
  en: {
    // Header
    nav: {
      services: "Services",
      fleet: "Fleet",
      reviews: "Reviews",
      contact: "Contact"
    },
    
    // Hero
    hero: {
      badge: "Premium NCC Service Turin",
      title: "Elegance and",
      titleHighlight: "Professionalism",
      titleEnd: "on the Road",
      subtitle: "Luxury NCC service with Mercedes V-Class. Airport transfers, corporate events and customized tours. Your premium travel experience in Turin.",
      trustBadge1: "Insured",
      trustBadge2: "24/7",
      trustBadge3: "5.0 Rating",
      ctaPrimary: "Book on WhatsApp",
      ctaSecondary: "Request Quote",
      scrollText: "Discover more"
    },
    
    // Services
    services: {
      badge: "Our Services",
      title: "Tailored Solutions for Every Need",
      subtitle: "From airport transfers to customized tours, we offer premium services for business and luxury clients",
      service1: {
        title: "Airport Transfers",
        description: "Professional service to and from Malpensa, Linate and Bergamo airports. Guaranteed punctuality and maximum comfort.",
        features: ["Flight monitoring", "Meet & Greet", "Luggage assistance"]
      },
      service2: {
        title: "Business Services",
        description: "Dedicated transport solutions for meetings, corporate events and business trips. Discretion and professionalism.",
        features: ["Electronic invoicing", "Continuous service", "Multi-destinations"]
      },
      service3: {
        title: "Ceremonies & Events",
        description: "Make your special day unforgettable with our premium service for weddings, anniversaries and celebrations.",
        features: ["Decorated car", "Personalized service", "Photographer available"]
      },
      service4: {
        title: "Langhe Tours",
        description: "Explore the wonders of Langhe with customized wine and food tours. Relax and discover the territory.",
        features: ["Custom itineraries", "Wineries & restaurants", "Tourist guide"]
      }
    },
    
    // Fleet
    fleet: {
      badge: "Our Fleet",
      title: "Our",
      titleHighlight: "Mercedes V-Class",
      subtitle: "Our premium vehicle for maximum comfort and style in your travels",
      vehicleBadge: "Our Vehicle",
      category: "Premium Van",
      passengers: "Passengers",
      luggage: "Luggage",
      color: "Black",
      comfortTitle: "Comfort & Services",
      features: ["Air conditioning", "Wi-Fi", "Leather seats", "Bottled water"],
      footer: "Our vehicle is regularly maintained, sanitized and fully insured"
    },
    
    // Testimonials
    testimonials: {
      badge: "Testimonials",
      title: "What Our Clients Say",
      subtitle: "Service excellence is measured by customer satisfaction",
      trustBadge: "on Google Reviews",
      reviews: [
        {
          id: 1,
          text: "Impeccable service. I have used Rent With Driver for several business transfers and never had any problems. Professional and punctual driver.",
          name: "Marco Bianchi",
          role: "CEO, Tech Solutions",
          date: "January 2025",
          rating: 5
        },
        {
          id: 2,
          text: "Our wedding was perfect also thanks to their service. Impeccable Mercedes and very kind driver. Highly recommended!",
          name: "Laura Rossi",
          role: "Bride",
          date: "December 2024",
          rating: 5
        },
        {
          id: 3,
          text: "I use this service for my transfers from Malpensa to Turin. Always punctual, comfortable and professional. Top!",
          name: "Giovanni Ferrari",
          role: "Business Traveler",
          date: "November 2024",
          rating: 5
        },
        {
          id: 4,
          text: "We had a wonderful tour in the Langhe. The driver knew all the best places. Experience to repeat!",
          name: "Sofia Martini",
          role: "Private Client",
          date: "October 2024",
          rating: 5
        }
      ]
    },
    
    // Coverage
    coverage: {
      badge: "Coverage Area",
      title: "Where We Operate",
      subtitle: "Reliable service from Turin to the main destinations in Northern Italy",
      fromTurin: "from Turin",
      footer1: "Destination not listed?",
      footer2: "Contact us for customized quotes to any destination in Italy"
    },
    
    // Contact
    contact: {
      badge: "Contact Us",
      title: "Request a Quote",
      subtitle: "Fill out the form or contact us directly on WhatsApp for an immediate quote",
      form: {
        name: "Full Name",
        email: "Email",
        phone: "Phone",
        service: "Service Requested",
        servicePlaceholder: "Select a service",
        serviceOptions: {
          airport: "Airport Transfer",
          business: "Business Service",
          ceremony: "Ceremony/Event",
          tour: "Langhe Tour",
          other: "Other"
        },
        date: "Expected Date",
        message: "Additional Notes",
        messagePlaceholder: "Trip details, number of passengers, luggage, etc...",
        submit: "Send Request on WhatsApp",
        required: "Please fill in all required fields",
        success: "Redirecting to WhatsApp..."
      },
      whatsapp: {
        title: "Direct Contact",
        subtitle: "Immediate response on WhatsApp",
        cta: "Chat on WhatsApp"
      },
      why: {
        title: "Why Choose Us?",
        reason1: "24/7 availability for emergencies and last-minute bookings",
        reason2: "Professional, discreet and multilingual drivers",
        reason3: "Luxury Mercedes vehicles, always impeccable",
        reason4: "Transparent rates with no hidden costs",
        reason5: "Flexible payments: cash, card, bank transfer"
      }
    },
    
    // Footer
    footer: {
      description: "Premium NCC service in Turin. Airport transfers, corporate events and customized tours with Mercedes V-Class.",
      quickLinks: "Quick Links",
      contacts: "Contacts",
      whatsapp24: "WhatsApp 24/7",
      location: "Turin, Piedmont",
      country: "Italy",
      copyright: "All rights reserved.",
      privacy: "Privacy Policy",
      terms: "Terms of Service"
    }
  }
};
